<ifc-base-dialog title="Draw funds"
                 [actions]="actions"
                 (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <ifm-action-select-form-field class="content"
                                  [data]="data"
                                  (selectChange)="onSelectChange($event)">
    </ifm-action-select-form-field>
  </ng-template>
</ifc-base-dialog>
